import React, { useState, useContext, useEffect } from "react";
import Filters from "../../components/list/Filters";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  addActiveFn
} from "../../components/action-buttons/ActionButtonGenerator";
import CurrencyInput from "../../components/form-fields/CurrencyInput";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import TextArea from "../../components/form-fields/TextArea";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { Field } from "formik";
import FileUpload from "../../components/fields/FileUpload";
import { Accordion, Button, Card } from "react-bootstrap";
import DocumentUpdate from "../home/document-update/DocumentUpdate";
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import { formatShortDate, formatListWithParameter, formatmarkInfo } from "../../utils";
import { useTranslation } from "react-i18next"; /* Added Line */
import request from "../../services/request";
import { ThemeContext } from '../../../context/ThemeContext';
import Checkbox from "../../components/form-fields/Checkbox";

function Ihtarnameler() {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filters, setFilters] = useState([]);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [companies, setCompanies] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [yurtici, setYurtici] = useState(-1);
  const [sirketDurumu, setSirketDurumu] = useState(-1);
  const [groups, setGroups] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  useEffect(() => {

    if (!configData) {
      return;
    }

    let data = configData?.grupSirketleri;
    
    if (yurtici != -1) {
      data = data.filter(grup => grup.yurtici == yurtici);
    }

    if (sirketDurumu != -1) {
      data = data.filter(grup => grup.isActive == (sirketDurumu == 90));
    }

    setGroups([...data]);
  }, [sirketDurumu, yurtici]);

  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("ihtarnameler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="ihtarnameler/config"
                    configParameterName="talepTurId"
                    configParameterValue={
                      selectedRow && selectedRow.talep.talepTurId
                    }
                    configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                        name="yurtici"
                        label={t("demandList.yurtici")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.yurtici}
                        onChangeFunc={(value) => {
                          let val = null;
                          if (value && value === 1) {
                            val = true;
                          } else if (value && value === 2) {
                            val = false;
                          }
                          setYurtici(val);
                        }}
                    />
                    <Field
                        name="sirketDurumu"
                        label={t("demandList.sirketDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.sirketDurumu}
                        onChangeFunc={(value) => { 
                          setSirketDurumu(value);
                        }}
                    />
                    <Field
                        name="isSubsidiary"
                        label={t("demandList.istirakSirketleri")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="islemNo"
                      label={t("ihtarnameler.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.departmanlar}
                      onChangeFunc={(val) => setDepartmanId(val) }
                    />
                    <Field
                      name="dosyaNo"
                      label={t("ihtarnameler.ihtarnameNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="taraf"
                      label={t("ihtarnameler.taraf")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="dosyaDurum"
                      label={t("ihtarnameler.durum")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.dosyaDurum}
                    />
                    <Field
                      name="group"
                      label={t("ihtarnameler.grup")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        groups || (configData && configData.grupSirketleri)
                      }
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                    />
                    <Field
                      name="sirketId"
                      label={t("ihtarnameler.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    />
                    <Field
                      name="dosyaTuru"
                      label={t("ihtarnameler.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        ((configData && configData.dosyaTurleri) || []).filter(a => departmanId ? a.otherValue == departmanId : true)
                      }
                    />
                    <Field
                      name="konu"
                      label={t("ihtarnameler.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="avukatId"
                      label={t("ihtarnameler.avukat")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.users}
                    />

                    <Field
                      name="acilisTarihiMin"
                      label={t("ihtarnameler.baslangicTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setStartDate(date)}}
                      maxDate={endDate}
                    />
                    <Field
                      name="kapanisTarihiMax"
                      label={t("ihtarnameler.bitisTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setEndDate(date)}}
                      minDate={startDate}
                    />
                    {/* <Field
                      name="onemli"
                      label={t("demandList.importantInfo")}
                      colNumber="3"
                      component={Checkbox}
                    /> */}
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DocumentUpdate
            title={"Tamamlananlar"}
            endpoint={"dosya/guncelle"}
            okButtonText={"Kaydet"}
            refreshList={refreshList}
            setRefreshList={setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow?.talep}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint="ihtarnameler/listele"
            keyField="id"
            refreshList={refreshList}
            customBody={{
              talepTurId: 22,
              filters: filters,
            }}
            hideSelection={true}
            columns={[
              {
                dataField: "talep.id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                headerStyle: {
                  width: 64
                }
              },
              // {
              //   dataField: "talep.onemli",
              //   text: `${t("demandList.importantInfo")}`,
              //   sort: false,
              //   formatter: formatmarkInfo,
              //   headerStyle: {
              //     width: 92
              //   }
              // },
              {
                dataField: "dosyaNo",
                text: `${t("demandList.ihtarnameNo")}`,
                sort: true,
              },
              {
                dataField: "talep.companyGroup",
                text: `${t("demandList.grup")}`,
                formatter: (data) => formatListWithParameter(data, "name"),
                sort: true,
              },
              {
                dataField: "talep.company.name",
                text: `${t("demandList.grupSirketi")}`,
                sort: true,
              },
              {
                dataField: "talep.taraf1",
                text: `${t("demandList.karsiTaraf")}`,
                sort: true,
              },
              {
                dataField: "talep.dosyaTur.dosyaTuru",
                text: `${t("demandList.ihtarnameTuru")}`,
                sort: true,
              },
              {
                dataField: "talep.konu",
                text: `${t("demandList.konu")}`,
                sort: true,
              },
              // {
              //   dataField: "baslangicTarihi",
              //   text: `${t("demandList.baslangicTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              // {
              //   dataField: "bitisTarihi",
              //   text: `${t("demandList.bitisTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              {
                dataField: "dosyaDurum.dosyaDurum",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
              {
                dataField: "talep.createdUser.fullName",
                text: `${t("demandList.ekleyen")}`,
                sort: true,
              },
              {
                dataField: "talep.cdate",
                text: `${t("demandList.eklemeTarihi")}`,
                sort: true,
                formatter: formatShortDate,
                headerStyle: {
                  width: 80
                }
              },
              {
                dataField: "talep.avukat.fullName",
                text: `${t("demandList.avukat")}`,
                sort: true,
              },
              {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
            }
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: "file/download-excel-arsiv",
                  talepTurId: 22
                }),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.talep.departmanYoneticisiMi
                )
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}

export default Ihtarnameler;
